import '../images/casestudy-analyticsImage.png';

// just like api response have kept a hardcoded mock api of objects

const EmbeddedCasestudyVideoListing = [
  {
    videoId: 'gcc-334b10b0-a4ef-401f-a7a9-070c6a876d80',
    title: 'Onboarding in Banking - Viewer led',
    description:
      'Equitas, Digital transformation, Customer Engagement, CSAT, Personalised info, viewer led experience',
    image: '../images/equitas.png',
    packageId: 'casestudy-1',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    interactivityBasedTags: [
      ' Personalised info',
      'Banking',
      'Personalization',
    ],
    tags: [
      'All',
      'Banking',
      'Customer Education',
      'Customer Success',
      'Customer onboarding',
      'Tile menu',
      'Branching',
      'Personalization',
    ],
    tryItOut: ['Personalization'],
    videoOrientation: 'horizontal',
    host: 'business.kpoint.com',
    visibility: 'private',
  },
  {
    videoId: 'gcc-8c3d0d87-07c8-4b7b-ac7a-e8dfb0afef4b',
    host: 'business.kpoint.com',
    title: 'Lead Capture - Acquiring Agents in General Insurance',
    description: 'ICICI-L, Reachout from video, in video Lead form',
    image: '../images/iciciRm.png',
    tags: [
      'All',
      'General Insurance',
      'Agent onboarding',
      'Reachout CTA',
      'CTA',
    ],
    interactivityBasedTags: ['CTA', 'General Insurance', 'Reachout CTA'],
    tryItOut: ['GroupCTA'],
    packageId: 'icici_casestudy1',
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-ae458ce5-a477-4059-8ded-7e0eeb71ba58',
    host: 'business.kpoint.com',
    title: 'Life Insurance renewal',
    description:
      'Exide Life (Now HDFC Life) - Encouraged Life Insurance renewals by equating Family security with life insurance.',
    image: '../images/exideLifeInsurance.png',
    tags: [
      'All',
      'General Insurance',
      'Agent onboarding',
      'Reachout CTA',
      'CTA',
    ],
    interactivityBasedTags: ['CTA', 'General Insurance', 'Reachout CTA'],
    tryItOut: [''],
    packageId: 'exide_insurance',
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-5f9f0163-0b8e-4561-ae25-c4f7fe484b29',
    title: 'Multilingual Video with AI VoiceOver',
    description:
      'Multilingual Video with AI VoiceOver | AI Voiceover | Multilingual',
    image: '../images/DentalQualysVoiceover.png',
    packageId: 'dental',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    tags: ['All', 'Multilingual', 'AI Voiceover'],
    interactivityBasedTags: [
      'AI',
      'Video Summary',
      'Multilingual',
      'Voice Clone',
      'AI Voiceover',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'qualys.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-6933d626-6441-4711-a6d5-678d7bc41e5d',
    title: 'Multilingual video with Voice Clone | sample 1',
    description:
      'Multilingual Video with AI VoiceOver | Voice Clone | Multilingual',
    image: '../images/DentalQualysVoiceover.png',
    packageId: 'elevenLabQualysVideoClone',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    tags: ['All', 'Multilingual', 'Voice Clone'],
    interactivityBasedTags: [
      'AI',
      'Video Summary',
      'Multilingual',
      'Voice Clone',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'business.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-1582410e-f3de-40d0-ab2f-182e471520cc',
    title: 'Multilingual video with Voice Clone | sample 2',
    description:
      'Multilingual Video with AI VoiceOver | Voice Clone | Multilingual',
    image: '../images/DentalQualysVoiceover.png',
    packageId: 'soniTranslateQualysVoiceClone',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    tags: ['All', 'Multilingual', 'Voice Clone'],
    interactivityBasedTags: [
      'AI',
      'Video Summary',
      'Multilingual',
      'Voice Clone',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'business.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-0bd34dbb-28cf-4a20-83e4-981a0c0d2828',
    host: 'ktpl.kpoint.com',
    title: 'Samsung Future Insight',
    description: 'Samsung Future Insight | Quarterly Newsletter ',
    image: '../images/samsungFutureInsight.png',
    tags: ['All', 'newsletter', 'tiles', 'customer awareness'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    packageId: 'samsungNewsletter',
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-24fbd2e5-b350-4990-a8a3-ccd74ae41b9f',
    host: 'ccoe.kpoint.com',
    title: 'Newsletter Form',
    description: 'Newsletter, Tiles, Customer Awareness',
    image: '../images/newsletterForm.png',
    tags: ['All', 'newsletter', 'tiles', 'customer awareness', 'CTA'],
    interactivityBasedTags: ['CTA', 'General Insurance', 'Reachout CTA'],
    tryItOut: [''],
    packageId: 'newsletterForms',
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-24fbd2e5-b350-4990-a8a3-ccd74ae41b9f',
    host: 'ccoe.kpoint.com',
    title: ' Newsletter',
    description: 'Newsletter, Tiles, Customer Awareness',
    image: '../images/TileMenu_Horizontal.png',
    tags: ['All', 'newsletter', 'tiles', 'customer awareness', 'CTA'],
    interactivityBasedTags: ['CTA', 'General Insurance', 'Reachout CTA'],
    tryItOut: [''],
    packageId: 'newsletterEngageHorizontalVersion',
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-a6d68d7b-ca7a-4f26-9537-6e691aa55907',
    host: 'ccoe.kpoint.com',
    title: 'Newsletter',
    description: 'Newsletter, Tiles, Customer Awareness',
    image: '../images/TileMenu_Verical.png',
    tags: ['All', 'newsletter', 'tiles', 'customer awareness', 'CTA'],
    interactivityBasedTags: ['CTA', 'General Insurance', 'Reachout CTA'],
    tryItOut: [''],
    packageId: 'newsletterVerticalVersionsVideo',
    videoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-7997d841-6e96-443e-b8dc-c4725f50e62a',
    host: 'ktpl.kpoint.com',
    title: 'Benefits of Life Insurance',
    description:
      'The video was created using the page https://www.kotaklife.com/insurance-guide/about-life-insurance/benefits-of-life-insurance',
    image: '../images/benefits-of-life-insurance.png',
    tags: ['All', 'General Insurance', 'customer awareness', 'CTA'],
    interactivityBasedTags: ['CTA', 'General Insurance', 'Reachout CTA'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    packageId: 'benefits-life-insurance',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-534f21df-f639-4030-889d-a08eb9a2b51a',
    title: 'Onboarding in Banking',
    description:
      'ABC Bank, Digital transformation, Customer Engagement, CSAT, viewer led experience',
    image: '../images/ABCBank_Thumbnail.png',
    packageId: 'casestudy',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    interactivityBasedTags: ['Personalised info', 'Banking', 'Personalization'],
    tags: [
      'All',
      'Banking',
      'Customer Education',
      'Customer Success',
      'Customer onboarding',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'ktpl.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-c73f8e06-f2d2-4d1d-ad9e-69556a3c21f4',
    host: 'business.kpoint.com',
    title: 'Lead Capture in Symposium / Events',
    description:
      'Samsung, B2B, B2C, Digital transformation,  in video Lead form',
    image: '../images/samsung-thumbnail.png',
    packageId: 'case-study-3',
    analytics: '../images/dummy-graph-casestudy.png',
    tags: ['All', 'Consumer Goods', 'Lead Generation', 'Custom Lead gen form'],
    interactivityBasedTags: ['Samsung', 'B2B'],
    tryItOut: ['CTA'],
    videoOrientation: 'vertical',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-3cf32e14-c5e0-4058-a583-df768801322c',
    host: 'business.kpoint.com',
    title:
      ' Customer Support Automation - DIY Troubleshooting for Order Returns',
    description:
      'Flipkart, reduce TAT, reduce Call Center Calls, CSAT, increase CLtV, increase regional reach, multi-lingual',
    image: '../images/flipkart-thumbnail.png',
    packageId: 'flipkartCasestudy',
    tags: [
      'All',
      'eComm',
      'Customer Support',
      'Multilingual',
      'Branching',
      'Feedback',
    ],
    interactivityBasedTags: ['Multilingual', 'Branching', 'Feedback'],
    tryItOut: ['Branching'],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-c3478710-28d3-4856-b245-3914eb013188',
    host: 'business.kpoint.com',
    title: 'Customer Support Automation Post Purchase - DIY Order Tracking',
    description:
      'Snapdeal, Reduce TAT, Reduce Call Center Calls, CSAT, Increase regional reach, multi-linguals',
    packageId: 'case-study-5',
    image: '../images/snapdeal-thumbnail.png',
    tags: [
      'All',
      'Retail',
      'Customer Success',
      'Customer Support',
      'Customer Education',
      'Helpdesk',
      'Multilingual',
      'Branching',
      'Feedback',
    ],
    interactivityBasedTags: ['Multilingual', 'Branching', 'Feedback'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-5a6b67c0-a8df-48df-9cc5-1775ad0a944b',
    host: 'business.kpoint.com',
    title: 'Sample Why Insurance for Different Target Audience',
    description:
      'Custom, Explainer, Simplify Info Share, Viewer led Experience, DIY Brand Specific Personalisation',
    image: '../images/whyinsurance-thumbnail.png',
    tags: [
      'All',
      'HDFC Life (Generic)',
      'Life Insurance',
      'Customer Education',
      'Personalization',
      'Reachout CTA',
      'Branching',
    ],
    interactivityBasedTags: [
      'Multilingual',
      'Branching',
      'Feedback',
      'Life Insurance',
      'Personalization',
      'Reachout CTA',
    ],
    packageId: 'engage-whyinsurance',
    tryItOut: ['Logo'],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-082ddacf-31ae-4c60-b356-7cb369978a38',
    host: 'business.kpoint.com',
    title: 'Customer Retention - Policy Renewal Reminder in Life Insurance',
    description:
      'HDFC Life, Increase CLtV, in-video Renewal initiation, Personalised Greeting, Personalised Policy Info',
    image: '../images/hdfclife.png',
    tags: [
      'All',
      'Personalization',
      'Life Insurance',
      'Renewal',
      'Retention',
      'Customer Support',
      'Customer Education',
      'Customer Success',
      'CTA',
      'Set Reminder',
    ],
    interactivityBasedTags: ['Personalization', 'CTA', 'Life Insurance'],
    packageId: 'hdfcLifeVideo1',
    tryItOut: ['Personalization'],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'private',
  },
  {
    videoId: 'gcc-d82516c9-b62a-4b1d-bfe2-41fffd35a43d',
    host: 'business.kpoint.com',
    title:
      'Customer Support Automation - Process Explainer in General Insurance',
    description:
      'ICICI-L, Reduce TAT, Reduce Call Center Calls, in-video App Download',
    image: '../images/ICICILOMBARD.png',
    tags: [
      'All',
      'General Insurance',
      'Customer Education',
      'Customer Success',
      'Customer Support',
      'Multilingual',
      'URL redirect',
      'Reachout CTA',
      'CTA',
    ],
    interactivityBasedTags: ['Multilingual', 'CTA', 'General Insurance'],
    packageId: 'casestudy-8',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-4b13af05-af04-4863-95c9-c2106fa534a4',
    host: 'business.kpoint.com',
    title:
      ' Customer Support - Process Explainer - Complaince - KYC in General Insurance',
    description:
      'ICICI-L, Digital transformation, Compliance, Reduce TAT for KYC, CSAT, Increase regional reach, Multi-lingual, Interactive Feedback',
    image: '../images/kyc.png',
    tags: [
      'All',
      'General Insurance',
      'Customer Education',
      'Customer Success',
      'Customer Support',
      'Multilingual',
      'Menu',
      'Reachout CTA',
      'CTA',
    ],
    interactivityBasedTags: [
      'Multilingual',
      'Feedback',
      'CTA',
      'General Insurance',
    ],
    packageId: 'casestudy-9',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-6688025e-3e86-442b-9aa1-54bc8c9b7f03',
    host: 'business.kpoint.com',
    title: ' Customer Awareness - Product Marketing in General Insurance',
    description: 'ICICI-L, Marketing',
    image: '../images/icici-healthadvantedge.png',
    tags: [
      'All',
      'General Insurance',
      'Customer Education',
      'Customer Success',
      'Multi-lingual',
      'Feedback',
    ],
    interactivityBasedTags: ['Multilingual', 'General Insurance', 'Feedback'],
    packageId: 'casestudy-10',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-f4a42ef1-6587-45af-b02b-7493305e451a',
    host: 'business.kpoint.com',
    title: 'Cross sell in B2C Diagnostic Care',
    description:
      'Redcliffe Lab, Hyperpersonalised cross sell, B2C, Customer Retention, Increase CLtV, in-video Booking',
    image: '../images/redcliffe.png',
    tags: [
      'All',
      'Retail',
      'Customer Education',
      'Retail',
      'Personalization',
      'CTA',
    ],
    interactivityBasedTags: ['CTA', 'Retail'],
    packageId: 'casestudy-11',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-dfb4e5c7-c6ef-462b-bd71-524fcf05bf93',
    host: 'business.kpoint.com',
    title:
      'Refurbish Content to Enable Product trial journey - Product Explainer',
    description:
      'Custom for Qualys, ITES, B2B, in-video Book Trial, in-video Query Form, Increase Global reach, multi-lingual',
    image: '../images/qualys.png',
    tags: [
      'All',
      'ITES',
      'Customer Education',
      'Product Explainer',
      'Reachout',
      'CTA',
    ],
    interactivityBasedTags: ['Reachout', 'CTA', 'ITES'],
    packageId: 'casestudy-12',
    tryItOut: ['CTA'],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'private',
  },
  {
    videoId: 'gcc-d06d619f-c683-4e69-a3f4-a9ae6c72013e',
    host: 'business.kpoint.com',
    title: 'Case Study of Consumer Product',
    description: 'Samsung, Digitise Case Study, Marketing',
    image: '../images/samsungknox.png',
    tags: ['All', 'Samsung', 'Retail', 'Lead generation', 'Menu', 'CTA'],
    interactivityBasedTags: ['Samsung', 'Retail', 'CTA', 'Reachout CTA'],
    packageId: 'casestudy-13',
    tryItOut: ['GroupCTA'],
    videoOrientation: 'horizontal',
    analytics: '../images/AnalyticsImage.png',
    dashboard: '../images/Engage Dashboard_2.png',
    visibility: 'private',
  },
  // yet to add diy
  {
    videoId: 'gcc-c9c45698-d0f7-495a-86ee-17fc808603ee',
    host: 'business.kpoint.com',
    title: 'Customer Support Automation Post Purchase - DIY Order Tracking',
    description:
      'Flipkart, Reduce TAT, Reduce Call Center Calls, Increase regional reach',
    image: '../images/flipkartproductstatus.png',
    tags: [
      'All',
      'Retail',
      'Customer Success',
      ' Customer Support',
      'Customer Education',
      'Retail',
      'Helpdesk',
      'Multilingual',
      'Branching',
      'Feedback',
    ],
    interactivityBasedTags: ['Multilingual', 'Branching', 'Feedback'],
    packageId: 'casestudy-14',
    tryItOut: [''],
    videoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-f6f8e6c1-730e-4327-a0ba-ba5ba2f0c815',
    host: 'business.kpoint.com',
    title: 'Lead Capture - Marketing Initiative',
    description:
      'KPOINT, Brand Awareness, Lead Capture, Product capability showcase',
    image: '../images/newyear.png',
    tags: [
      'All',
      'Travel',
      'Customer Education',
      'Marketing',
      'campaign',
      'Personalization',
      'Branching',
      'CTA',
    ],
    interactivityBasedTags: ['Personalization', 'Branching', 'CTA'],
    packageId: 'casestudy-15',
    tryItOut: ['Personalization'],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-55c77190-220b-4b89-9774-cedd94e6ac31',
    host: 'business.kpoint.com',
    title: 'Personalized enterprise communication',
    description:
      'KPOINT, Brand Awareness, Lead Capture, Product capability showcase',
    image: '../images/bagic_english.jpg',
    tags: [
      'All',
      'Customer Education',
      'Marketing',
      'campaign',
      'lip sync',
      'multi language',
      'Voice Cloning',
      'Audio synthesis',
    ],
    interactivityBasedTags: [
      'lip sync',
      'multi language',
      'Voice Cloning',
      'Audio synthesis',
    ],
    packageId: 'english',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-072ca50a-df4d-46ef-af63-0923663413ee',
    host: 'business.kpoint.com',
    title: 'Personalized enterprise communication',
    description:
      'KPOINT, Brand Awareness, Lead Capture, Product capability showcase',
    image: '../images/bagic_hindi.jpg',
    tags: [
      'All',
      'Customer Education',
      'Marketing',
      'campaign',
      'lip sync',
      'multi language',
      'Voice Cloning',
      'Audio synthesis',
    ],
    interactivityBasedTags: [
      'lip sync',
      'multi language',
      'Voice Cloning',
      'Audio synthesis',
    ],
    packageId: 'hindi',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-f47861d8-0567-4746-8329-7a898b4667d3',
    host: 'business.kpoint.com',
    title: 'Bajaj Finance Limited I Chairman’s Message Original',
    description:
      'Bajaj Finance Limited I Chairman’s Message | Automatic AI Reels',
    image: '../images/bajaj-finance.png',
    tags: ['All', 'Customer Education', 'AI', 'Video Summary'],
    interactivityBasedTags: ['AI', 'Video Summary'],
    packageId: 'aiReels',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-514c3296-8f54-4cc0-a143-0a568b6d6cff',
    host: 'business.kpoint.com',
    title: 'Bajaj Finance Limited I Chairman’s Message',
    description:
      'Bajaj Finance Limited I Chairman’s Message | Automatic AI Reels',
    image: '../images/bajaj-finance.png',
    tags: ['All', 'Customer Education', 'AI', 'Video Summary'],
    interactivityBasedTags: ['AI', 'Video Summary'],
    packageId: 'aiReels',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-7b8f5e3c-983c-484d-947d-fe7478559c80',
    host: 'business.kpoint.com',
    title: 'Stanford Webinar - Cryptocurrencies and Blockchains Original',
    description:
      'Stanford Webinar - Cryptocurrencies and Blockchains | Summarized',
    image: '../images/blockchain_crypto.png',
    tags: ['All', 'Customer Education', 'AI', 'Video Summary'],
    interactivityBasedTags: ['AI', 'Video Summary'],
    packageId: 'aiReelsBlockChain',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-11986dc7-f983-420d-8782-3a2fa30730be',
    host: 'business.kpoint.com',
    title: 'Stanford Webinar - Cryptocurrencies and Blockchains',
    description:
      'Stanford Webinar - Cryptocurrencies and Blockchains | Summarized',
    image: '../images/blockchain_crypto.png',
    tags: ['All', 'Customer Education', 'AI', 'Video Summary'],
    interactivityBasedTags: ['AI', 'Video Summary'],
    packageId: 'aiReelsBlockChain',
    tryItOut: [''],
    videoOrientation: 'horizontal',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-e46f440a-3e3e-4190-a6fd-11364eea1a28',
    host: 'business.kpoint.com',
    title: 'mAdhar marketing campaigns(HINDI)',
    description: '',
    image: '../images/mAdhar.png',
    tags: ['All', 'Customer Education', 'AI', 'Video Summary'],
    interactivityBasedTags: ['AI', 'Video Summary'],
    packageId: 'mAdharHindiVideo1',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-da891b7a-e0be-4709-80ad-6a36e66265c3',
    host: 'business.kpoint.com',
    title: 'mAdhar marketing campaigns(MARATHI)',
    description: '',
    image: '../images/mAdhar.png',
    tags: ['All', 'Customer Education', 'AI', 'Video Summary'],
    interactivityBasedTags: ['AI', 'Video Summary'],
    packageId: 'mAdharVideoMarathi',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-e454b831-e1ee-4195-8067-2d561aa656ba',
    title: 'Onboarding in Banking',
    description:
      'ABC Bank, Digital transformation, Customer Engagement, CSAT, viewer led experience',
    image: '../images/dbs.png',
    packageId: 'engageDbsBank',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    interactivityBasedTags: ['Personalised info', 'Banking', 'Personalization'],
    tags: [
      'All',
      'Banking',
      'Customer Education',
      'Customer Success',
      'Customer onboarding',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'ccoe.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-d101c594-1b64-4649-ac67-f1ff848f3d6f',
    title: 'Casestudy of Somnath Temple',
    description:
      'Somnath Temple,  Customer Engagement, CSAT, viewer led experience',
    image: '../images/qci.png',
    packageId: 'engage_qci',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    interactivityBasedTags: ['Personalised info', 'Banking', 'Personalization'],
    tags: [
      'All',
      'Banking',
      'Customer Education',
      'Customer Success',
      'Customer onboarding',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'ccoe.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-5e5199db-ed08-49c5-a665-dc33771e2dfb',
    title: 'Casestudy of Zenith',
    description: 'Zenith,  Customer Engagement, CSAT, viewer led experience',
    image: '../images/zenith.png',
    packageId: 'zenith-engage',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    interactivityBasedTags: ['Personalised info', 'Banking', 'Personalization'],
    tags: [
      'All',
      'Banking',
      'Customer Education',
      'Customer Success',
      'Customer onboarding',
    ],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    host: 'ccoe.kpoint.com',
    visibility: 'public',
  },
  {
    videoId: 'gcc-0a390ae7-2000-412d-9c31-dda8541d71be',
    host: 'business.kpoint.com',
    title: 'Personalized marketing campaigns',
    image: '',
    tags: ['All', 'Customer Education', 'Voice Cloning', 'Audio synthesis'],
    packageId: 'insurance',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    listing: 'no',
    visibility: 'public',
  },
  {
    videoId: 'gcc-6224827a-bb58-4fd1-96aa-2fb326a7cf63',
    host: 'ccoe.kpoint.com',
    title: 'Axis Max Life pitch',
    image: '../images/axisMaxLife.png',
    tags: ['All', 'Customer Education', 'Voice Cloning', 'Audio synthesis'],
    packageId: 'axis-max-life',
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  // Added from CCOE/Interactivity tracker sheet - no thumbnails available yet,
  // hence image: '' + listing: 'no' (hidden from public grid, reachable by videoId)
  {
    videoId: 'gcc-0d96d3d0-d056-44a8-b6dd-17dd06e4a3c7',
    host: 'ccoe.kpoint.com',
    packageId: 'onboarding',
    lang: 'hindi',
    title: 'Customer Onboarding (Hindi, Rebranded)',
    description: 'Axis Max Life, Rebranded customer onboarding video, Hindi',
    image: '../images/maxlife_hindi.png',
    tags: ['All', 'Life Insurance', 'Customer onboarding', 'Multilingual'],
    interactivityBasedTags: ['Personalization'],
    tryItOut: ['Personalization'],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    personalizationInfo: {
      name: 'Pratyaksh sharma',
    },
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-0d96d3d0-d056-44a8-b6dd-17dd06e4a3c7',
    host: 'ccoe.kpoint.com',
    packageId: 'onboarding',
    lang: 'english',
    title: 'Customer Onboarding (English)',
    description:
      'Axis Max Life, Onboarding video with interactive personalization',
    image: '../images/maxlife_english.png',
    tags: ['All', 'Life Insurance', 'Customer onboarding', 'Personalization'],
    interactivityBasedTags: ['Personalization'],
    tryItOut: ['Personalization'],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  //icici travel vertical videos
  {
    videoId: 'gcc-8e08bbcf-bd9f-4453-8283-80aee34c88b1',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel-hb',
    title: 'Travel Insurance Guide - Master (Vertical)',
    description:
      'ICICI Lombard, Travel insurance customer support guide, viewer led chapters',
    image: '../images/icici_lombard.png',
    tags: [
      'All',
      'General Insurance',
      'Customer Support',
      'Tile menu',
      'Unbranding',
    ],
    interactivityBasedTags: ['Tile menu', 'General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-85dccb06-d68f-4ef7-9453-d78181aba8a4',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel-hb',
    title: 'Travel Insurance - Getting Help During Your Trip (Vertical)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/getting-help-vertical.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-517825ad-a1f6-413f-a90e-497ef7534a5d',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel-hb',
    title: 'Travel Insurance - Cashless Claims (Vertical)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/claim-status-vertical.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-e66375ee-2965-4828-ac9a-311b07619619',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel-hb',
    title: 'Travel Insurance - Reimbursement Claims (Vertical)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/reimbursement-vertical.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-dcd392f9-9154-4b66-a8d1-646b6e8f7642',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel-hb',
    title: 'Travel Insurance - Documents Required & FAQs (Vertical)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/document-vertical.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-8a18815e-f22c-40e5-bf07-cc37ea200cf3',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel-hb',
    title: 'Travel Insurance - Tracking Claim Status (Vertical)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/icici_lombard.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },

  {
    videoId: 'gcc-4cfed2f2-1615-41ab-bf76-0897d4833f05',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel',
    title: 'Travel Insurance Guide - Master (Horizontal)',
    description:
      'ICICI Lombard, Travel insurance customer support guide, viewer led chapters',
    image: '../images/icicilombardhorizental.png',
    tags: ['All', 'General Insurance', 'Customer Support', 'Tile menu'],
    interactivityBasedTags: ['Tile menu', 'General Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-1eb7474c-46d6-4818-876e-925276f6fbd0',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel',
    title: 'Travel Insurance - Getting Help During Your Trip (Horizontal)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/gettinghelp.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-afb0f39e-609c-4484-b725-c34bd0711412',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel',
    title: 'Travel Insurance - Cashless Claims (Horizontal)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/cashless-claim.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-2ccace88-1fb0-41ef-bdaf-f6be71bbe9d0',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel',
    title: 'Travel Insurance - Reimbursement Claims (Horizontal)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/reimbursement.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-93c1d79b-bb6c-4204-8bb9-496244c4b49e',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel',
    title: 'Travel Insurance - Documents Required & FAQs (Horizontal)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/document-faq.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-e548c804-f915-4be2-a9c1-717205fcadc2',
    host: 'customersupport-icicilombard.kpoint.com',
    packageId: 'icici-travel',
    title: 'Travel Insurance - Tracking Claim Status (Horizontal)',
    description: 'ICICI Lombard, Travel insurance customer support chapter',
    image: '../images/claim-status.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-2516cac7-b495-4305-9f8d-5ce1a7a33cd8',
    host: 'ccoe.kpoint.com',
    packageId: 'renewalreminder',
    title: 'ABC Bank - Renewal Reminder',
    description:
      'ABC Bank, Personalised policy renewal reminder video, Unbranding',
    image: '../images/abcbank-renewal.png',
    tags: [
      'All',
      'Personalization',
      'Renewal',
      'Customer Retention',
      'Unbranding',
    ],
    interactivityBasedTags: ['Personalization'],
    tryItOut: ['Personalization'],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    personalizationInfo: {
      name: 'Pratyaksh sharma',
    },
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-32d93c65-b4ad-49a0-89b6-f7794efc146b',
    host: 'ccoe.kpoint.com',
    title: 'Protect Me Well - Customer Acquisition POC',
    description:
      'Universal Sompo General Insurance, Customer acquisition proof of concept',
    image: '../images/protectmewells.png',
    tags: ['All', 'General Insurance', 'Customer Acquisition'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-b6f76f79-8600-4855-a900-eae0f06ef862',
    host: 'ccoe.kpoint.com',
    packageId: 'iciciRenewNow',
    title: 'ICICI Lombard - Motor Insurance Renewal',
    description:
      'ICICI Lombard, Personalised motor policy renewal reminder with in-video Renew Now CTA',
    image: '../images/orion.png',
    tags: ['All', 'General Insurance', 'Renewal', 'CTA', 'Personalization'],
    interactivityBasedTags: ['CTA', 'Personalization', 'General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-4f123219-2119-491a-a8ca-ed89bc551fe3',
    host: 'abfl.kpoint.com',
    packageId: 'abfl',
    title: 'ABFL - Video KYC Reminder',
    description:
      'Aditya Birla Finance, Personalised Video KYC completion reminder with in-video Start VKYC CTA',
    image: '../images/abflvertical.png',
    tags: ['All', 'NBFC', 'KYC', 'CTA', 'Personalization'],
    interactivityBasedTags: ['CTA', 'Personalization'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    personalizationInfo: {
      entityId: 'CH001',
      first_name: 'Ajay',
    },
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-8a124420-f60d-48a8-8b22-4ccdeac5fbfc',
    host: 'ccoe.kpoint.com',
    title: 'Qualys - Rebranding Output',
    description: 'Qualys, Customer satisfaction survey with AI avatar',
    image: '../images/qualysrebranding.png',
    tags: ['All', 'Customer Success', 'AI', 'Multilingual'],
    videoOrientation: 'vertical',
    interactivityBasedTags: ['AI'],
    tryItOut: [''],
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-7fa1c7ed-1ddd-4557-84e5-597aaf95fd73',
    host: 'ccoe.kpoint.com',
    packageId: 'icicipruvideo1',
    title: 'ICICI Prudential - Agent Invitation Video',
    description: 'ICICI Prudential, Agent invitation and onboarding video',
    image: '../images/icicipru.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding'],
    interactivityBasedTags: ['Life Insurance'],
    tryItOut: [''],
    videoOrientation: 'horizontal',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-76a6d1dc-77a2-479b-823d-ce31ff0409ff',
    host: 'ccoe.kpoint.com',
    title: 'Swayam AI Promo',
    description: 'Swayam, AI promo video, Unbranding',
    image: '../images/swayam.png',
    tags: ['All', 'AI', 'Unbranding'],
    interactivityBasedTags: ['AI'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-23aebfef-a1cf-4c30-b942-76d725b96253',
    host: 'ccoe.kpoint.com',
    title: 'PLAY Agent 1 - BOP (English)',
    description:
      'ICICI Prudential, PLAY Agent onboarding video series, English',
    image: '../images/play-agent1-bop-english.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding', 'Multilingual'],
    interactivityBasedTags: ['Multilingual'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-6ad09062-7323-4012-b917-44539ebda1e6',
    host: 'ccoe.kpoint.com',
    title: 'PLAY Agent 1 - BOP (Hindi)',
    description: 'ICICI Prudential, PLAY Agent onboarding video series, Hindi',
    image: '../images/play-agent1-bop-hindi.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding', 'Multilingual'],
    interactivityBasedTags: ['Multilingual'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-9439734c-f014-4b06-8736-50a2a2e71bef',
    host: 'ccoe.kpoint.com',
    title: 'PLAY Agent 2 - BOP (English)',
    description:
      'ICICI Prudential, PLAY Agent onboarding video series, English',
    image: '../images/play-agent2-bop-english.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding', 'Multilingual'],
    interactivityBasedTags: ['Multilingual'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-824a942a-8248-45c5-b6b6-90bfb9e8a995',
    host: 'ccoe.kpoint.com',
    title: 'PLAY Agent 2 - BOP (Hindi)',
    description: 'ICICI Prudential, PLAY Agent onboarding video series, Hindi',
    image: '../images/play-agent2-bop-hindi.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding', 'Multilingual'],
    interactivityBasedTags: ['Multilingual'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-9e104f0e-6c14-4892-b2eb-68628e4eb230',
    host: 'ccoe.kpoint.com',
    title: 'PLAY Agent 3 - BOP (English)',
    description:
      'ICICI Prudential, PLAY Agent onboarding video series, English',
    image: '../images/play-agent3-bop-english.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding', 'Multilingual'],
    interactivityBasedTags: ['Multilingual'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-57389936-b3ea-4193-8191-f272912fde46',
    host: 'ccoe.kpoint.com',
    title: 'PLAY Agent 3 - BOP (Hindi)',
    description: 'ICICI Prudential, PLAY Agent onboarding video series, Hindi',
    image: '../images/play-agent3-bop-hindi.png',
    tags: ['All', 'Life Insurance', 'Agent onboarding', 'Multilingual'],
    interactivityBasedTags: ['Multilingual'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'gcc-4e38d662-8b99-4eae-bcdc-2ce3a1379685',
    host: 'ccoe.kpoint.com',
    title: 'IL Edit Policy',
    description: 'ICICI Lombard, Edit policy reel with avatar-led guidance',
    image: '../images/il-edit-policy.png',
    tags: ['All', 'General Insurance', 'Customer Support'],
    interactivityBasedTags: ['General Insurance'],
    tryItOut: [''],
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    analytics: '../images/casestudy-analyticsImage.png',
    dashboard: '../images/EngageDashboard_1.png',
    visibility: 'public',
  },
  {
    videoId: 'experience-abc-bop',
    title: 'ABC BOP - Interactive Video & AI Guide',
    description:
      'ABC Life Insurance, Full-screen persona-branching video with an AI chat guide for the advisor recruitment journey',
    image: '../images/abcbop.png',
    tags: ['All', 'AI', 'Personalization', 'Unbranding', 'Agent onboarding'],
    interactivityBasedTags: ['Experience'],
    externalUrl: '/experiences/abc-bop/',
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    visibility: 'public',
  },
  {
    videoId: 'experience-pramerica',
    title: 'Pramerica - Video KYC',
    description:
      'Pramerica Life Insurance, Interactive Video KYC flow with consent, camera recording, and identity confirmation',
    image: '../images/pramerica.png',
    tags: ['All', 'KYC', 'Personalization'],
    interactivityBasedTags: ['Experience'],
    externalUrl: '/experiences/pramerica/',
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    visibility: 'public',
  },
  {
    videoId: 'experience-hdfc-life-pre-issuance',
    title: 'HDFC Life Pre Issuance',
    description: 'HDFC LIFE Pre Issuance Rebranding',
    image: '../images/hdfclife-pre.png',
    tags: ['All', 'KYC', 'Personalization', 'Life Insurance'],
    interactivityBasedTags: ['Experience'],
    externalUrl: '/experiences/hdfc-life-pre-issuance/',
    videoOrientation: 'vertical',
    specificVideoOrientation: 'vertical',
    visibility: 'public',
  },
];

export default EmbeddedCasestudyVideoListing;
